import React from 'react'
import appLogo from "../../assets/images/bistatech-logo.jpg"
import "./CopyRightMessage.scss"
const CopyRightMessage = () => {
    return (
        <div className='copy-right-message-container'>
            <div className="copy-right-message-wrapper">
                <a href="https://bistatechnology.com" target={'_blank'} rel="noreferrer">
                    <img className='copy-right-message-logo' src={appLogo} alt="app-logo" />
                    <p>
                        طراحی و توسعه توسط بیستاتِک
                    </p>
                </a>
            </div>
        </div>
    )
}
export default CopyRightMessage